<em class="{{icon}}"></em>
<div>
  <h2>{{title | lang}}</h2>
  <p>{{description | lang}}</p>
  <small>{{notes | lang}}</small>
</div>

